import React from 'react';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import ProfileCustomClearIcon from '../../../HelperIcons/ProfileCustomClearIcon';

const CustomTextArea = ({
  index,
  field,
  onChange,
  onClear,
  shudClearBtnRender,
}) => (
    <div style={{ position: 'relative', width: '100%' }}>
      <TextField
        value={field.value}
        disabled={field.disabled}
        onChange={(e) => onChange(index, e)}
        multiline
        minRows={4}
        sx={{
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'transparent',
              border: 'none',
            },
            '&:hover fieldset': {
              borderColor: 'transparent',
              border: 'none',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'transparent',
              border: 'none',
            },
          },
          '& .MuiInputBase-root': {
            border: field.disabled ? 'none' : '2px solid #F3F3FA',
            outline: 'none',
          },
          '& .MuiInputBase-input': {
            outline: 'none',
            color: '#727484',
            'WebkitTextFillColor': '#727484 !important',
            fontWeight: '400',
            fontSize: '1rem',
            fontFamily: 'Figtree-Regular',
          },
          width: '100%',
          // padding: '10px',
        }}
      />
      {shudClearBtnRender && !field.disabled && (
        <IconButton
          aria-label="clear"
          onClick={(e) => onClear(index, e)}
          edge="end"
          sx={{
            position: 'absolute',
            top: '40%',
            right: '20px',
          }}
        >
          <ProfileCustomClearIcon
            sx={{
              backgroundColor: field.disabled ? 'transparent' : 'lightgrey',
              color: 'white',
              borderRadius: '50%',
              width: '18px',
              height: '18px',
            }}
          />
        </IconButton>
      )}
    </div>
);

export default CustomTextArea;
